import { jsx } from 'react/jsx-runtime';
import { getResourceHtmlPreview } from '../../resources/utils/getResourceHtmlPreview.js';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

const DocumentHtmlPreview = ({ resource }) => {
  const htmlPreview = resource && getResourceHtmlPreview(resource);
  if (!htmlPreview) return null;
  return /* @__PURE__ */ jsx(VisuallyHidden, {
    children: /* @__PURE__ */ jsx("div", {
      dangerouslySetInnerHTML: {
        __html: htmlPreview
      }
    })
  });
};

export { DocumentHtmlPreview };
//# sourceMappingURL=DocumentHtmlPreview.js.map
